module.exports = __webpack_public_path__ + "img/cisco-logo.d691cf2e.png";